<template>
  <div class="p-config-edit-ga-version">
    <div class="p-config-edit-ga-version__title">
      <p>表示するGoogle Analyticsデータの選択</p>
    </div>
    <div>
      <p>
        Google
        Analyticsの連携データを機能別で選択して表示することができます。<span
          v-if="!isAuthority"
          class="c-text--accent"
          >サイト限定ユーザーの場合は切り替えることができません。アカウント管理者に確認してください。</span
        >
      </p>
    </div>
    <div class="l-mt-3 c-alertPos">
      <table class="c-table">
        <tbody>
          <tr>
            <th class="bg">GA・GSCデータサマリー</th>
            <td>
              <RadioGroupGaVersion
                v-model="params.gaVersion.gaGscDataSummary"
                :name="gaVersionKey.gaGscDataSummary"
                :disabled="isDisabled"
              ></RadioGroupGaVersion>
            </td>
          </tr>
          <tr>
            <th class="bg">自社キーワード分析</th>
            <td>
              <RadioGroupGaVersion
                v-model="params.gaVersion.siteKeywordAnalysis"
                :name="gaVersionKey.siteKeywordAnalysis"
                :disabled="isDisabled"
              ></RadioGroupGaVersion>
            </td>
          </tr>
          <tr>
            <th class="bg">成果チェック</th>
            <td>
              <RadioGroupGaVersion
                v-model="params.gaVersion.siteImportantKeyword"
                :name="gaVersionKey.siteImportantKeyword"
                :disabled="isDisabled"
              ></RadioGroupGaVersion>
            </td>
          </tr>
        </tbody>
      </table>
      <Alert v-if="error.gaVersion">
        {{ error.gaVersion }}
      </Alert>
    </div>
    <Note>
      <template slot="title">
        <p>
          表示データ変更時の注意点
        </p>
      </template>
      <p>
        連携直後の場合、Google Analyticsのバージョンを変更した際に、SEARCH
        WRITE上にすべてのデータを表示されるまでに<strong>「最大で48時間」</strong>かかる場合がございます。
      </p>
    </Note>
  </div>
</template>

<script>
import apiProjects from '@/api/projects';
import Alert from '@/components/Alert';
import Note from '@/components/Note';
import RadioGroupGaVersion from '@/components/config/RadioGroupGaVersion';
import { GA_VERSION_KEY } from '@/constants';
export default {
  props: ['project'],
  components: {
    Alert,
    Note,
    RadioGroupGaVersion
  },
  data() {
    return {
      error: {
        gaVersion: ''
      },
      gaVersionKey: GA_VERSION_KEY,
      params: {
        gaVersion: {
          [GA_VERSION_KEY.gaGscDataSummary]: 'ua',
          [GA_VERSION_KEY.siteKeywordAnalysis]: 'ua',
          [GA_VERSION_KEY.siteImportantKeyword]: 'ua'
        }
      },
      temp: {
        gaVersion: {
          [GA_VERSION_KEY.gaGscDataSummary]: 'ua',
          [GA_VERSION_KEY.siteKeywordAnalysis]: 'ua',
          [GA_VERSION_KEY.siteImportantKeyword]: 'ua'
        }
      },
      isError: false,
      isLoading: true,
      isProcessing: false
    };
  },
  computed: {
    isAuthority() {
      return this.$store.state.user.me.organization.isAuthority;
    },
    isDisabled() {
      return (
        this.$store.state.user.me.isEmployee ||
        this.$store.state.user.me.isSwAdmin ||
        !this.isAuthority ||
        this.isError ||
        this.isLoading ||
        this.isProcessing
      );
    },
    gaVersion() {
      return this.$store.state.project.gaVersion;
    }
  },
  watch: {
    gaVersion: {
      handler(value, oldValue) {
        this.params.gaVersion = Object.assign({}, value);
        this.temp.gaVersion = Object.assign({}, value);
      },
      deep: true
    },
    'params.gaVersion': {
      handler(value, oldValue) {
        if (this.isDisabled) {
          return;
        }
        this.isProcessing = true;
        this.error.gaVersion = '';
        const gaVersion = Object.entries(this.params.gaVersion).reduce(
          (acc, [key, value]) => {
            acc[key] = value.toUpperCase();
            return acc;
          },
          {}
        );
        apiProjects.gaVersion
          .put(gaVersion, this.auth.idToken, this.project.id)
          .then(async () => {
            this.temp.gaVersion = Object.assign({}, this.params.gaVersion);
          })
          .catch(() => {
            // 元の設定に戻す
            this.params.gaVersion = Object.assign({}, this.temp.gaVersion);
            this.error.gaVersion = '表示設定の更新に失敗しました';
          })
          .finally(() => {
            this.isProcessing = false;
          });
      },
      deep: true
    }
  },
  created() {
    this.$store
      .dispatch('project/getGaVersion')
      .then(gaVersion => {
        this.params.gaVersion = Object.assign({}, gaVersion);
        this.temp.gaVersion = Object.assign({}, gaVersion);
      })
      .catch(() => {
        this.isError = true;
        this.error.gaVersion = '表示設定の取得に失敗しました';
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
};
</script>
